import IdentificationPage from 'containers/IdentificationPage';
import PreOpeningPage from 'containers/PreOpeningPage';
import UploadDocuments from 'containers/UploadDocuments';
import RecapPage from 'containers/RecapPage';
import HomePage from 'containers/HomePage';
import LoginPage from 'containers/LoginPage';
import ManagerHomePage from 'containers/ManagerHomePage';
import ManagerRejectedClaimsPage from 'containers/ManagerRejectedClaimsPage';
import PendingClaimsPage from 'containers/PendingClaimsPage';
import RecapManagerPage from 'containers/RecapManagerPage';
import AppContainer from 'containers/AppContainer';
import ManagerPendingClaims from 'containers/ManagerPendingClaims';
import ValidatedClaimsPage from 'containers/ValidatedClaimsPage';
import ManagerOpenedClaimsPage from 'containers/ManagerOpenedClaimsPage';
import LawyerRecapPage from 'containers/LawyerRecapPage';
import RejectedClaimsPage from 'containers/RejectedClaimsPage';
import ManagerDocumentsPage from 'containers/ManagerDocumentsPage';
import NewDocumentPage from 'containers/LawyerDocumentsPage';
import CourtManagerAssignedClaims from 'containers/CourtManagerAssignedClaims';
import LawyerAssignmentsPage from 'containers/LawyerAssignmentsPage';
import LawyerLegalProceedingsPage from 'containers/LawyerLegalProceedingsPage';
import CourtManagerLegalProceedingsPage from 'containers/CourtManagerLegalProceedings';
import LawyerFeeNote from 'containers/LawyerFeeNote';
import ManagerFeeNote from 'containers/ManagerFeeNote';
import IdentificationManagerPage from 'containers/IdentificationManagerPage';
import CourtManagerAssignedExpertise from 'containers/CourtManagerAssignedExpertise';
import ExpertAssignedMission from 'containers/ExpertAssignedMissions';
import ExpertAssignedMissionShow from 'containers/ExpertAssignedMissionShow';
import CourtMonitoringManagerLegalProceedingsPage from 'containers/CourtMonitoringManagerLegalProccedings';
import ExpertFeeNote from 'containers/ExpertFeeNote';
import ExpertCompletedMission from 'containers/ExpertCompletedMission';
import ExpertHomePage from 'containers/ExpertHomePage';
import OpeningPageManager from 'containers/OpeningClaimPageManager';
import CourtManagerLockedClaimPage from 'containers/CourtManagerLockedClaim';
import AttributionManagerPage from 'containers/AttributionManager';
import ConvertClaimOpeningManager from 'containers/ConvertClaimOpeningManager';
import UploadDocumentsManager from 'containers/UploadDocumentsManager';
import PreOpenManagerHomePage from 'containers/PreOpenManagerHomePage';
import ValidatedPreOpenManagerClaims from 'containers/PreOpenManagerValidatedClaims';
import PreOpenManagerRejectedClaims from 'containers/PreOpenManagerRejectedClaims';
import PreOpenManagerPendingClaims from 'containers/PreOpenManagerPendingClaims';
import PreOpenManagerRecapPage from 'containers/PreOpenManagerRecapPage';
import ManagerPendingTreatementClaims from 'containers/ManagerPendingTreatementClaims';
import RegulationRecapPage from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapPage';
import ConsultationLegalProceedingPage from 'containers/ConsultationLegalProceedingPage/index';
import JudiciaryProcessPage from 'containers/BasicManagement/judiciaryProcessPage';
import ConsultationOpeningPage from 'containers/ConsultationOpening/index';
import PreOpenManagerFeeNote from 'containers/PreOpenManagerFeeNote/index';
import TransactionManagerHomePage from 'containers/TransactionManagerHomePage/index';
import AttributionOpeningManagerPage from 'containers/AttributionManager/AttributionOpening';
import AttributionJudiciaryManagerPage from 'containers/AttributionManager/AttributionJudiciary';
import AttributionTransactionManagerPage from 'containers/AttributionManager/AttributionTransaction';
import TransactionManagerTimeLinePage from 'containers/TransactionManagerTimeLine/index';
import PreOpeningManagerPage from 'containers/PreOpenManagerPage';
import ManagerManagement from 'containers/ManagerManagement';
import IntervenantManagement from 'containers/IntervenantManagement';
import ProvisionalClaimsPage from 'containers/ProvisionalClaimsPage';
import ProvisionalClaimRecap from 'containers/ProvisionalClaimRecap';
import UsageClaimsPage from 'containers/UsageClaimsPage';
export const PAGES = {
  ROOT: '/',
  LAWYER_HOME: '/',
  MANAGER_HOME: '/manager',
  PREOPEN_MANAGER_HOME: '/preopen-manager',
  MONITORING_MANAGER_HOME: '/monitoring-manager',
  IDENTIFICATION: '/identification',
  IDENTIFICATION_PV: '/manager/identification-manager',
  IDENTIFICATION_PREOPEN_MANAGER: '/preopen-manager/identification',
  PREOPEN_CLAIM_PREOPEN_MANAGER: '/preopen-manager/claim',
  UPLOAD_DOCUMENTS_PREOPEN_MANAGER: '/preopen-manager/upload-documents',
  RECAPITULATIF_PREOPEN_MANAGER: '/preopen-manager/recapitulatif',
  PREOPEN_MANAGER_PENDING_CLAIMS: '/preopen-manager/pending-claims',
  PREOPEN_MANAGER_VALIDATED_CLAIMS: '/preopen-manager/validated-claims',
  PREOPEN_MANAGER_REJECTED_CLAIMS: '/preopen-manager/rejected-claims',
  PREOPEN_MANAGER_FEE_NOTE: '/preopen-manager/fee-note',
  PREOPEN_MANAGER_RECAP_PAGE: '/preopen-manager/recap',
  PREOPENING: '/pre-opening',
  PREOPENING_MANAGER: '/court-manager/pre-opening',
  PREOPENING_MANAGER_UPLOAD_DOCUMENTS: '/court-manager/upload-documents',
  PREOPENING_MANAGER_RECAPITULATIF: '/court-manager/recapitulatif',
  PREOPENING_MANAGER_JUDICIARY_PROCESS: '/court-manager/judiciary-process',
  UPLOAD_DOCUMENTS: '/upload-documents',
  RECAPITULATIF: '/recapitulatif',
  JUDICIARY_PROCESS: '/judiciary-process',
  RECAP: '/recap',
  LOGIN_MANAGER: '/manager/login',
  MANAGER_REJECTED_CLAIMS: '/manager/rejected-claims',
  PENDING_CLAIMS: '/pending-claims',
  USAGE_CLAIMS: '/usage-claims',
  MANAGER_RECAP_PAGE: '/manager/recap',
  MANAGER_PENDING_CLAIMS: '/manager/pending-claims',
  VALIDATED_CLAIMS: '/validated-claims',
  MANAGER_OPENED_CLAIMS: '/manager/opened-claims',
  REJECTED_CLAIMS: '/rejected-claims',
  MANAGER_DOCUMENTS: '/manager/documents',
  NEW_DOCUMENTS: '/documents',
  COURT_MANAGER_HOME: '/court-manager',
  COURT_MANAGER_ASSIGNED_CLAIM: '/court-manager/assigned-claim',
  LAWYER_ASSIGNMENTS: '/lawyer-assignments',
  LEGAL_PROCEEDINGS: '/legal-proceedings',
  COURT_MANAGER_LEGAL_PROCEEDINGS: '/manager/legal-procedding',
  COURT_MONITORING_MANAGER_LEGAL_PROCEEDINGS:
    '/monitoring-manager/legal-procedding',
  FEE_NOTE: '/fee-note',
  MANAGER_FEE_NOTE: '/manager/fee-note',
  COURT_MONITORING_MANAGER_ASSINGED_EXPERTISE:
    '/court-manager/assigned-expertise',
  EXPERT_HOME: '/',
  EXPERT_ASSIGNED_MISSIONS: '/expert/assigned-missions',
  EXPERT_ASSIGNED_MISSION_SHOW: '/expert/assigned-missions/missions',
  EXPERT_FEE_NOTE: '/expert/fee-note',
  EXPERT_COMPLETED_MISSIONS: '/expert/completed-missions',
  OPENING_CLAIM: '/manager/opening-claim',
  UPLOAD_DOCUMENTS_MANAGER: '/manager/upload-documents',
  RECAPITULATIF_MANAGER: '/manager/recapitulatif',
  MANAGER_LOCKED_CLAIM: '/manager/locked-claim',
  ATTRIBUTION_MANAGER_PAGE: '/manager/attribution',
  CONVERT_CLAIM_MANAGER_PAGE: '/manager/convert-claim',
  MANAGER_PENDING_TREATEMENT_CLAIMS: '/manager/pending-treatement',
  MANAGER_RECAP_REGULATION_PAGE: '/manager/recap-regulation',
  CONSULTATION_LEGAL_PROCEEDING_PAGE: '/manager/consultation-page',
  CONSULTATION_MANAGER_HOME: '/consult-manager',
  CONSULATION_OPENING_PAGE: '/manager/consultation-opening-page',
  TRANSACTION_MANAGER_HOME: '/transaction-manager',
  TRANSACTION_MANAGER_FEE_NOTE: '/transaction-manager/fee-note',
  ATTRIBUTION_OPENING_MANAGER_PAGE: '/manager/attribution-opening',
  ATTRIBUTION_JUDICIARY_MANAGER_PAGE: '/manager/attribution-judiciary',
  ATTRIBUTION_TRANSACTION_MANAGER_PAGE: '/manager/attribution-transaction',
  TRANSACTION_LEGAL_PROCEDDING: '/transaction-manager/legal-procedding',
  TRANSACTION_MANAGER_PENDING_TREATEMENT_CLAIMS:
    '/transaction-manager/pending-treatement',
  PLATFORM_MANAGER_MANAGEMENT: '/manager/platform-manager/managers',
  PLATFORM_MANAGER_MANAGEMENT_INTERVENANT:
    '/manager/platform-manager/intervenants',
  COURT_MONITORING_PROVISIONAL_CLAIMS: '/court-manager/provisional-claims',
  COURT_MONITORING_PROVISIONAL_CLAIMS_RECAP:
    '/court-manager/provisional-claims-recap',
  PROVISIONAL_CLAIMS_RECAP: '/provisional-claims-recap',
  PROVISIONAL_CLAIMS: '/provisional-claims',
};

export const PAGES_INDEX = [
  PAGES.IDENTIFICATION,
  PAGES.PREOPENING,
  PAGES.UPLOAD_DOCUMENTS,
  PAGES.RECAPITULATIF,
];

export const PAGES_INDEX_MANAGER = [
  PAGES.OPENING_CLAIM,
  PAGES.UPLOAD_DOCUMENTS_MANAGER,
  PAGES.RECAPITULATIF_MANAGER,
];
export const PAGES_INDEX_COURT_MANAGER = [
  PAGES.PREOPENING_MANAGER,
  PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS,
  PAGES.PREOPENING_MANAGER_RECAPITULATIF,
];

export const ROUTES = [
  {
    path: PAGES.LOGIN_MANAGER,
    exact: true,
    component: LoginPage,
  },
  {
    path: PAGES.ROOT,
    component: AppContainer,
  },
];

export const EXPERT_ROUTES = [
  {
    path: PAGES.EXPERT_HOME,
    exact: true,
    component: ExpertHomePage,
  },
  {
    path: PAGES.EXPERT_ASSIGNED_MISSIONS,
    exact: true,
    component: ExpertAssignedMission,
  },
  {
    path: `${PAGES.EXPERT_ASSIGNED_MISSION_SHOW}/:missionId`,
    component: ExpertAssignedMissionShow,
  },
  {
    path: PAGES.EXPERT_FEE_NOTE,
    component: ExpertFeeNote,
  },
  {
    path: PAGES.EXPERT_COMPLETED_MISSIONS,
    component: ExpertCompletedMission,
  },
];

export const MANAGER_ROUTES = [
  {
    path: PAGES.LOGIN_MANAGER,
    exact: true,
    component: LoginPage,
  },
  {
    path: PAGES.IDENTIFICATION_PV,
    component: IdentificationManagerPage,
  },
  {
    path: PAGES.MANAGER_HOME,
    exact: true,
    component: ManagerHomePage,
  },
  {
    path: PAGES.MANAGER_REJECTED_CLAIMS,
    component: ManagerRejectedClaimsPage,
  },
  {
    path: PAGES.MANAGER_PENDING_CLAIMS,
    component: ManagerPendingClaims,
  },
  {
    path: `${PAGES.MANAGER_RECAP_PAGE}/:claimId`,
    component: RecapManagerPage,
  },
  {
    path: PAGES.MANAGER_OPENED_CLAIMS,
    component: ManagerOpenedClaimsPage,
  },
  {
    path: PAGES.MANAGER_DOCUMENTS,
    component: ManagerDocumentsPage,
  },
  {
    path: PAGES.MANAGER_FEE_NOTE,
    component: ManagerFeeNote,
  },
  {
    path: PAGES.OPENING_CLAIM,
    component: OpeningPageManager,
  },
  {
    path: PAGES.UPLOAD_DOCUMENTS_MANAGER,
    component: UploadDocumentsManager,
  },
  {
    path: PAGES.RECAPITULATIF_MANAGER,
    component: RecapPage,
  },
  {
    path: PAGES.ATTRIBUTION_MANAGER_PAGE,
    component: AttributionManagerPage,
  },
  {
    path: PAGES.CONVERT_CLAIM_MANAGER_PAGE,
    component: ConvertClaimOpeningManager,
  },
  {
    path: `${PAGES.MANAGER_LOCKED_CLAIM}/:claimId`,
    exact: true,
    component: CourtManagerLockedClaimPage,
  },
  {
    path: PAGES.MANAGER_PENDING_TREATEMENT_CLAIMS,
    component: ManagerPendingTreatementClaims,
  },
  {
    path: `${PAGES.MANAGER_RECAP_REGULATION_PAGE}/:claimNumber/:paymentId`,
    component: RegulationRecapPage,
  },
  {
    path: PAGES.CONSULTATION_MANAGER_HOME,
    component: ManagerHomePage,
  },
  {
    path: `${PAGES.CONSULATION_OPENING_PAGE}/:claimId`,
    component: ConsultationOpeningPage,
  },
  {
    path: PAGES.ATTRIBUTION_OPENING_MANAGER_PAGE,
    component: AttributionOpeningManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_JUDICIARY_MANAGER_PAGE,
    component: AttributionJudiciaryManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_TRANSACTION_MANAGER_PAGE,
    component: AttributionTransactionManagerPage,
  },
  {
    path: PAGES.PLATFORM_MANAGER_MANAGEMENT,
    component: ManagerManagement,
  },
  {
    path: PAGES.PLATFORM_MANAGER_MANAGEMENT_INTERVENANT,
    component: IntervenantManagement,
  },
];

export const LAWYER_ROUTES = [
  {
    path: PAGES.IDENTIFICATION,
    component: IdentificationPage,
  },
  {
    path: PAGES.PREOPENING,
    component: PreOpeningPage,
  },
  {
    path: PAGES.UPLOAD_DOCUMENTS,
    component: UploadDocuments,
  },
  {
    path: PAGES.RECAPITULATIF,
    component: RecapPage,
  },
  {
    path: PAGES.JUDICIARY_PROCESS,
    component: JudiciaryProcessPage,
  },
  {
    path: PAGES.LAWYER_HOME,
    exact: true,
    component: HomePage,
  },
  {
    path: PAGES.PENDING_CLAIMS,
    component: PendingClaimsPage,
  },
  {
    path: PAGES.USAGE_CLAIMS,
    component: UsageClaimsPage,
  },
  {
    path: PAGES.VALIDATED_CLAIMS,
    component: ValidatedClaimsPage,
  },
  {
    path: `${PAGES.RECAP}/:claimId`,
    component: LawyerRecapPage,
  },
  {
    path: PAGES.REJECTED_CLAIMS,
    component: RejectedClaimsPage,
  },
  {
    path: PAGES.NEW_DOCUMENTS,
    component: NewDocumentPage,
  },
  {
    path: PAGES.LAWYER_ASSIGNMENTS,
    component: LawyerAssignmentsPage,
  },
  {
    path: `${PAGES.LEGAL_PROCEEDINGS}/:claimId`,
    component: LawyerLegalProceedingsPage,
  },
  {
    path: PAGES.FEE_NOTE,
    component: LawyerFeeNote,
  },
  {
    path: `${PAGES.COURT_MONITORING_MANAGER_LEGAL_PROCEEDINGS}/:claimId`,
    exact: true,
    component: CourtMonitoringManagerLegalProceedingsPage,
  },
  {
    path: `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/:claimId`,
    exact: true,
    component: ConsultationLegalProceedingPage,
  },
  {
    path: `${PAGES.PROVISIONAL_CLAIMS_RECAP}/:provisionalClaimId`,
    component: ProvisionalClaimRecap,
  },
  {
    path: PAGES.PROVISIONAL_CLAIMS,
    component: ProvisionalClaimsPage,
  },
];

export const COURT_MANAGER_ROUTES = [
  {
    path: PAGES.COURT_MANAGER_HOME,
    exact: true,
    component: ManagerHomePage,
  },
  {
    path: PAGES.COURT_MANAGER_ASSIGNED_CLAIM,
    component: CourtManagerAssignedClaims,
  },
  {
    path: `${PAGES.MANAGER_RECAP_PAGE}/:claimId`,
    component: RecapManagerPage,
  },
  {
    path: `${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/:claimId`,
    component: CourtManagerLegalProceedingsPage,
  },
  {
    path: `${PAGES.MANAGER_FEE_NOTE}`,
    component: ManagerFeeNote,
  },
  {
    path: PAGES.COURT_MONITORING_MANAGER_ASSINGED_EXPERTISE,
    component: CourtManagerAssignedExpertise,
  },
  {
    path: `${PAGES.COURT_MONITORING_MANAGER_LEGAL_PROCEEDINGS}/:claimId`,
    exact: true,
    component: CourtMonitoringManagerLegalProceedingsPage,
  },
  {
    path: `${PAGES.MANAGER_LOCKED_CLAIM}/:claimId`,
    exact: true,
    component: CourtManagerLockedClaimPage,
  },
  {
    path: PAGES.ATTRIBUTION_MANAGER_PAGE,
    component: AttributionManagerPage,
  },
  {
    path: PAGES.MANAGER_PENDING_TREATEMENT_CLAIMS,
    component: ManagerPendingTreatementClaims,
  },
  {
    path: `${PAGES.MANAGER_RECAP_REGULATION_PAGE}/:claimNumber/:paymentId`,
    component: RegulationRecapPage,
  },
  {
    path: `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/:claimId`,
    exact: true,
    component: ConsultationLegalProceedingPage,
  },
  {
    path: PAGES.PREOPENING_MANAGER,
    component: PreOpeningManagerPage,
  },
  {
    path: PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS,
    component: UploadDocumentsManager,
  },
  {
    path: PAGES.PREOPENING_MANAGER_RECAPITULATIF,
    component: RecapPage,
  },
  {
    path: PAGES.PREOPENING_MANAGER_JUDICIARY_PROCESS,
    component: JudiciaryProcessPage,
  },
  {
    path: PAGES.ATTRIBUTION_OPENING_MANAGER_PAGE,
    component: AttributionOpeningManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_JUDICIARY_MANAGER_PAGE,
    component: AttributionJudiciaryManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_TRANSACTION_MANAGER_PAGE,
    component: AttributionTransactionManagerPage,
  },
  {
    path: PAGES.PLATFORM_MANAGER_MANAGEMENT,
    component: ManagerManagement,
  },
  {
    path: PAGES.PLATFORM_MANAGER_MANAGEMENT_INTERVENANT,
    component: IntervenantManagement,
  },
  {
    path: PAGES.COURT_MONITORING_PROVISIONAL_CLAIMS,
    component: ProvisionalClaimsPage,
  },
  {
    path: `${PAGES.COURT_MONITORING_PROVISIONAL_CLAIMS_RECAP}/:provisionalClaimId`,
    component: ProvisionalClaimRecap,
  },
];

export const PREOPEN_MANAGER_ROUTES = [
  {
    path: PAGES.PREOPEN_MANAGER_HOME,
    exact: true,
    component: PreOpenManagerHomePage,
  },
  {
    path: PAGES.IDENTIFICATION_PREOPEN_MANAGER,
    component: IdentificationManagerPage,
  },
  {
    path: PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER,
    component: PreOpeningPage,
  },
  {
    path: PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER,
    component: UploadDocumentsManager,
  },
  {
    path: PAGES.RECAPITULATIF_PREOPEN_MANAGER,
    component: RecapPage,
  },
  {
    path: PAGES.PREOPEN_MANAGER_VALIDATED_CLAIMS,
    component: ValidatedPreOpenManagerClaims,
  },
  {
    path: PAGES.PREOPEN_MANAGER_REJECTED_CLAIMS,
    component: PreOpenManagerRejectedClaims,
  },
  {
    path: PAGES.PREOPEN_MANAGER_PENDING_CLAIMS,
    component: PreOpenManagerPendingClaims,
  },
  {
    path: `${PAGES.PREOPEN_MANAGER_RECAP_PAGE}/:claimId`,
    component: PreOpenManagerRecapPage,
  },
  {
    path: PAGES.PREOPEN_MANAGER_FEE_NOTE,
    component: PreOpenManagerFeeNote,
  },
];

export const PAGES_INDEX_PREOPEN_MANAGER = [
  PAGES.IDENTIFICATION_PREOPEN_MANAGER,
  PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER,
  PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER,
  PAGES.RECAPITULATIF_PREOPEN_MANAGER,
];
export const ISCONSULTATION_MANAGER_ROUTES = [
  {
    path: PAGES.CONSULTATION_MANAGER_HOME,
    component: ManagerHomePage,
  },
  {
    path: `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/:claimId`,
    exact: true,
    component: ConsultationLegalProceedingPage,
  },
];

export const TRANSACTION_MANAGER_ROUTES = [
  {
    path: PAGES.TRANSACTION_MANAGER_HOME,
    exact: true,
    component: TransactionManagerHomePage,
  },
  {
    path: PAGES.TRANSACTION_MANAGER_FEE_NOTE,
    exact: true,
    component: ManagerFeeNote,
  },
  {
    path: `${PAGES.TRANSACTION_LEGAL_PROCEDDING}/:claimId`,
    exact: true,
    component: TransactionManagerTimeLinePage,
  },
  {
    path: `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/:claimId`,
    exact: true,
    component: ConsultationLegalProceedingPage,
  },
  {
    path: PAGES.TRANSACTION_MANAGER_PENDING_TREATEMENT_CLAIMS,
    component: ManagerPendingTreatementClaims,
  },
  {
    path: PAGES.ATTRIBUTION_TRANSACTION_MANAGER_PAGE,
    component: AttributionTransactionManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_OPENING_MANAGER_PAGE,
    component: AttributionOpeningManagerPage,
  },
  {
    path: PAGES.ATTRIBUTION_JUDICIARY_MANAGER_PAGE,
    component: AttributionJudiciaryManagerPage,
  },
];
